<p-toast></p-toast>
<p-progressBar mode="indeterminate" *ngIf="loading"></p-progressBar>

<app-page-shell>
  <app-page-hero
    eyebrow="Shipments"
    title="Internal Transport Costs"
    subtitle="Manage company-owned city-to-city transport cost cards used as margin basis for shipment planning.">
    <div actions>
      <p-button *ngIf="canImport" label="Template XLSX" icon="pi pi-download" severity="secondary" [outlined]="true"
        (onClick)="downloadTemplate('xlsx')"></p-button>
      <p-button *ngIf="canImport" label="Template CSV" icon="pi pi-file" severity="secondary" [outlined]="true"
        (onClick)="downloadTemplate('csv')"></p-button>
      <p-button *ngIf="canCreate" label="Add Cost Card" icon="fa-solid fa-plus" (onClick)="openCreate()"></p-button>
    </div>
  </app-page-hero>

  <app-page-metric-strip [metrics]="metrics()"></app-page-metric-strip>

  <app-page-data-panel
    title="Filters"
    subtitle="Filter internal cost cards by lane, vehicle, status, date, or keyword."
    [collapsible]="true"
    [initiallyCollapsed]="true">
    <div class="formgrid grid">
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="fa-solid fa-globe"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select id="filter-source-country" [options]="countries" [(ngModel)]="filterSourceCountryId"
              [ngModelOptions]="{ standalone: true }" optionLabel="name" optionValue="id" [showClear]="true"
              [filter]="true" filterBy="name,countryCode" (ngModelChange)="onFilterSourceCountryChange()" styleClass="w-full"></p-select>
            <label for="filter-source-country">Source Country</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="fa-solid fa-location-dot"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select id="filter-source-city" [options]="filterSourceCities" [(ngModel)]="filterSourceCityId"
              [ngModelOptions]="{ standalone: true }" optionLabel="cityName" optionValue="id" [showClear]="true"
              [filter]="true" filterBy="cityName" [disabled]="!filterSourceCountryId" styleClass="w-full"></p-select>
            <label for="filter-source-city">Source City</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="fa-solid fa-globe"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select id="filter-destination-country" [options]="countries" [(ngModel)]="filterDestinationCountryId"
              [ngModelOptions]="{ standalone: true }" optionLabel="name" optionValue="id" [showClear]="true"
              [filter]="true" filterBy="name,countryCode" (ngModelChange)="onFilterDestinationCountryChange()" styleClass="w-full"></p-select>
            <label for="filter-destination-country">Destination Country</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="fa-solid fa-location-dot"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select id="filter-destination-city" [options]="filterDestinationCities" [(ngModel)]="filterDestinationCityId"
              [ngModelOptions]="{ standalone: true }" optionLabel="cityName" optionValue="id" [showClear]="true"
              [filter]="true" filterBy="cityName" [disabled]="!filterDestinationCountryId" styleClass="w-full"></p-select>
            <label for="filter-destination-city">Destination City</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-iftaLabel>
          <p-select id="filter-vehicle-type" [options]="vehicleTypes" [(ngModel)]="filterVehicleTypeId"
            [ngModelOptions]="{ standalone: true }" optionLabel="name" optionValue="id" [showClear]="true"
            (ngModelChange)="onFilterVehicleTypeChange()" styleClass="w-full"></p-select>
          <label for="filter-vehicle-type">Vehicle Type</label>
        </p-iftaLabel>
      </div>
      <div class="field col-12 md:col-3">
        <p-iftaLabel>
          <p-select id="filter-vehicle-config" [options]="filterVehicleConfigs"
            [(ngModel)]="filterVehicleConfigId" [ngModelOptions]="{ standalone: true }" optionLabel="name" optionValue="configId"
            [showClear]="true" [disabled]="!filterVehicleTypeId" styleClass="w-full"></p-select>
          <label for="filter-vehicle-config">Vehicle Config</label>
        </p-iftaLabel>
      </div>
      <div class="field col-12 md:col-3">
        <p-iftaLabel>
          <p-select id="filter-vehicle-capacity" [options]="filterVehicleCapacities"
            [(ngModel)]="filterVehicleCapacityId" [ngModelOptions]="{ standalone: true }" optionLabel="name" optionValue="capacityId"
            [showClear]="true" [disabled]="!filterVehicleTypeId" styleClass="w-full"></p-select>
          <label for="filter-vehicle-capacity">Vehicle Capacity</label>
        </p-iftaLabel>
      </div>
      <div class="field col-12 md:col-3">
        <p-iftaLabel>
          <p-select id="filter-status" [options]="statusOptions" [(ngModel)]="filterStatus"
            [ngModelOptions]="{ standalone: true }" optionLabel="label" optionValue="value" styleClass="w-full"></p-select>
          <label for="filter-status">Status</label>
        </p-iftaLabel>
      </div>
      <div class="field col-12 md:col-4">
        <p-iftaLabel>
          <p-datePicker id="filter-effective-on" [(ngModel)]="filterEffectiveOn" [ngModelOptions]="{ standalone: true }"
            [showIcon]="false" dateFormat="yy-mm-dd" styleClass="w-full"></p-datePicker>
          <label for="filter-effective-on">Effective On</label>
        </p-iftaLabel>
      </div>
      <div class="field col-12 md:col-5">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-search"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <input id="filter-keyword" pInputText [(ngModel)]="keyword" [ngModelOptions]="{ standalone: true }" class="w-full" />
            <label for="filter-keyword">Keyword</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3 filter-actions">
        <p-button label="Apply" icon="pi pi-filter" (onClick)="applyFilters()"></p-button>
        <p-button label="Clear" icon="pi pi-times" severity="secondary" [outlined]="true" (onClick)="clearFilters()"></p-button>
      </div>
    </div>
  </app-page-data-panel>

  <app-page-data-panel
    title="Cost Cards"
    subtitle="Active and historical internal transport costs for this company."
    [resultText]="totalRecords + ' cost cards'">
    <p-table
      [value]="cards"
      [loading]="loading"
      [lazy]="true"
      [lazyLoadOnInit]="false"
      (onLazyLoad)="loadCards($event)"
      [paginator]="true"
      [first]="first"
      [rows]="pageSize"
      [totalRecords]="totalRecords"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} cost cards"
      responsiveLayout="scroll">
      <ng-template pTemplate="header">
        <tr>
          <th>Lane</th>
          <th>Vehicle</th>
          <th>Base Cost</th>
          <th>Waiting Terms</th>
          <th>Effective Window</th>
          <th>Status</th>
          <th>Notes</th>
          <th *ngIf="canEdit">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-card>
        <tr>
          <td>
            <div class="lane-cell">
              <strong>{{ card.sourceCityName || '-' }} -> {{ card.destinationCityName || '-' }}</strong>
              <small>{{ card.sourceCountryName || '-' }} -> {{ card.destinationCountryName || '-' }}</small>
            </div>
          </td>
          <td>
            <div class="lane-cell">
              <strong>{{ card.vehicleTypeName || '-' }}</strong>
              <small>{{ card.vehicleConfigName || 'Any config' }} | {{ card.vehicleCapacityName || 'Any capacity' }}</small>
            </div>
          </td>
          <td>{{ card.baseCostAmount || 0 | number:'1.2-2' }} {{ currencyLabel(card) }}</td>
          <td>{{ card.waitingThresholdMinutes || 0 }} min / {{ card.waitingChargeAmount || 0 | number:'1.2-2' }} {{ currencyLabel(card) }}</td>
          <td>{{ formatDateValue(card.effectiveStartDate) }} to {{ formatDateValue(card.effectiveEndDate) }}</td>
          <td><p-tag [value]="card.status || 'ACTIVE'" [severity]="statusSeverity(card.status)"></p-tag></td>
          <td>{{ card.notes || '-' }}</td>
          <td *ngIf="canEdit">
            <p-button icon="fa-solid fa-pen" severity="secondary" [outlined]="true" (onClick)="openEdit(card)"></p-button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="canEdit ? 8 : 7">No internal transport cost cards match the current filters.</td>
        </tr>
      </ng-template>
    </p-table>
  </app-page-data-panel>

  <app-page-data-panel title="Bulk Import" subtitle="Upload, review, correct, and process internal transport cost rows." *ngIf="canImport">
    <div class="import-toolbar">
      <input #importInput type="file" class="hidden-input" (change)="onFileSelected($event)" />
      <p-button label="Choose File" icon="pi pi-upload" severity="secondary" [outlined]="true" (onClick)="importInput.click()"></p-button>
      <span class="selected-file">{{ importFile?.name || 'No file selected' }}</span>
      <p-button label="Upload" icon="fa-solid fa-cloud-arrow-up" [disabled]="!importFile" (onClick)="uploadImport()"></p-button>
      <p-button label="Process Valid Rows" icon="fa-solid fa-check" severity="success" [disabled]="!currentImport?.batch?.batchId"
        [loading]="processing" (onClick)="processBatch()"></p-button>
    </div>

    <div class="import-batches" *ngIf="importBatches.length > 0">
      <strong>Recent Batches</strong>
      <div class="batch-list">
        <button type="button" class="batch-chip" *ngFor="let batch of importBatches" (click)="openBatch(batch)">
          {{ batch.fileName || ('Batch #' + batch.batchId) }} | {{ batch.status }}
        </button>
      </div>
    </div>

    <p-table [value]="currentImport?.rows || []" responsiveLayout="scroll">
      <ng-template pTemplate="header">
        <tr>
          <th>Row</th>
          <th>Status</th>
          <th>Lane</th>
          <th>Vehicle</th>
          <th>Cost</th>
          <th>Effective</th>
          <th>Error</th>
          <th>Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{ row.rowNumber || row.rowId }}</td>
          <td><p-tag [value]="row.status" [severity]="statusSeverity(row.status)"></p-tag></td>
          <td>{{ rowImportValue(row, 'sourceCity') }} -> {{ rowImportValue(row, 'destinationCity') }}</td>
          <td>{{ rowImportValue(row, 'vehicleType') }} / {{ rowImportValue(row, 'vehicleConfig') }}</td>
          <td>{{ rowImportValue(row, 'baseCostAmount') }} {{ rowImportValue(row, 'currencyCode') }}</td>
          <td>{{ rowImportValue(row, 'effectiveStartDate') }} to {{ rowImportValue(row, 'effectiveEndDate') }}</td>
          <td>{{ row.errorMessage || '-' }}</td>
          <td class="row-actions">
            <p-button icon="fa-solid fa-pen" severity="secondary" [outlined]="true" (onClick)="openEditRow(row)"></p-button>
            <p-button icon="fa-solid fa-rotate-right" severity="help" [outlined]="true"
              [disabled]="row.status !== 'FAILED' && row.status !== 'VALID'" (onClick)="retryRow(row)"></p-button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8">No import batch is open.</td>
        </tr>
      </ng-template>
    </p-table>
  </app-page-data-panel>
</app-page-shell>

<p-dialog [(visible)]="formVisible" [modal]="true" [draggable]="false" [resizable]="false"
  [style]="{ width: 'min(980px, 96vw)' }"
  [header]="costForm.internalTransportCostCardId ? 'Edit Internal Transport Cost' : 'Create Internal Transport Cost'">
  <div class="formgrid grid">
    <div class="field col-12 md:col-3">
      <p-iftaLabel>
        <p-select id="form-source-country" [options]="countries" [(ngModel)]="costForm.sourceCountryId"
          optionLabel="name" optionValue="id" [filter]="true" filterBy="name,countryCode" [showClear]="true"
          (ngModelChange)="onFormSourceCountryChange()" styleClass="w-full"></p-select>
        <label for="form-source-country">Source Country</label>
      </p-iftaLabel>
    </div>
    <div class="field col-12 md:col-3">
      <p-iftaLabel>
        <p-select id="form-source-city" [options]="formSourceCities" [(ngModel)]="costForm.sourceCityId"
          optionLabel="cityName" optionValue="id" [filter]="true" filterBy="cityName" [showClear]="true"
          [disabled]="!costForm.sourceCountryId" styleClass="w-full"></p-select>
        <label for="form-source-city">Source City</label>
      </p-iftaLabel>
    </div>
    <div class="field col-12 md:col-3">
      <p-iftaLabel>
        <p-select id="form-destination-country" [options]="countries" [(ngModel)]="costForm.destinationCountryId"
          optionLabel="name" optionValue="id" [filter]="true" filterBy="name,countryCode" [showClear]="true"
          (ngModelChange)="onFormDestinationCountryChange()" styleClass="w-full"></p-select>
        <label for="form-destination-country">Destination Country</label>
      </p-iftaLabel>
    </div>
    <div class="field col-12 md:col-3">
      <p-iftaLabel>
        <p-select id="form-destination-city" [options]="formDestinationCities" [(ngModel)]="costForm.destinationCityId"
          optionLabel="cityName" optionValue="id" [filter]="true" filterBy="cityName" [showClear]="true"
          [disabled]="!costForm.destinationCountryId" styleClass="w-full"></p-select>
        <label for="form-destination-city">Destination City</label>
      </p-iftaLabel>
    </div>

    <div class="field col-12 md:col-4">
      <p-iftaLabel>
        <p-select id="form-vehicle-type" [options]="vehicleTypes" [(ngModel)]="costForm.vehicleTypeId"
          optionLabel="name" optionValue="id" (ngModelChange)="onFormVehicleTypeChange()" styleClass="w-full"></p-select>
        <label for="form-vehicle-type">Vehicle Type</label>
      </p-iftaLabel>
    </div>
    <div class="field col-12 md:col-4">
      <p-iftaLabel>
        <p-select id="form-vehicle-config" [options]="formVehicleConfigs" [(ngModel)]="costForm.vehicleConfigId"
          optionLabel="name" optionValue="configId" [showClear]="true" [disabled]="!costForm.vehicleTypeId" styleClass="w-full"></p-select>
        <label for="form-vehicle-config">Vehicle Config</label>
      </p-iftaLabel>
    </div>
    <div class="field col-12 md:col-4">
      <p-iftaLabel>
        <p-select id="form-vehicle-capacity" [options]="formVehicleCapacities" [(ngModel)]="costForm.vehicleCapacityId"
          optionLabel="name" optionValue="capacityId" [showClear]="true" [disabled]="!costForm.vehicleTypeId" styleClass="w-full"></p-select>
        <label for="form-vehicle-capacity">Vehicle Capacity</label>
      </p-iftaLabel>
    </div>

    <div class="field col-12 md:col-3">
      <p-iftaLabel>
        <p-inputNumber id="form-base-cost" [(ngModel)]="costForm.baseCostAmount" mode="currency" [currency]="costForm.currencyCode || 'SAR'" styleClass="w-full"></p-inputNumber>
        <label for="form-base-cost">Base Cost</label>
      </p-iftaLabel>
    </div>
    <div class="field col-12 md:col-3">
      <p-iftaLabel>
        <input id="form-currency" pInputText [(ngModel)]="costForm.currencyCode" maxlength="3" />
        <label for="form-currency">Currency</label>
      </p-iftaLabel>
    </div>
    <div class="field col-12 md:col-3">
      <p-iftaLabel>
        <p-inputNumber id="form-waiting-threshold" [(ngModel)]="costForm.waitingThresholdMinutes" styleClass="w-full"></p-inputNumber>
        <label for="form-waiting-threshold">Waiting Threshold Minutes</label>
      </p-iftaLabel>
    </div>
    <div class="field col-12 md:col-3">
      <p-iftaLabel>
        <p-inputNumber id="form-waiting-charge" [(ngModel)]="costForm.waitingChargeAmount" mode="currency" [currency]="costForm.currencyCode || 'SAR'" styleClass="w-full"></p-inputNumber>
        <label for="form-waiting-charge">Waiting Charge</label>
      </p-iftaLabel>
    </div>

    <div class="field col-12 md:col-4">
      <p-iftaLabel>
        <p-datePicker id="form-effective-start" [(ngModel)]="formEffectiveStartDate" [showIcon]="false" dateFormat="yy-mm-dd" styleClass="w-full"></p-datePicker>
        <label for="form-effective-start">Effective Start</label>
      </p-iftaLabel>
    </div>
    <div class="field col-12 md:col-4">
      <p-iftaLabel>
        <p-datePicker id="form-effective-end" [(ngModel)]="formEffectiveEndDate" [showIcon]="false" dateFormat="yy-mm-dd" styleClass="w-full"></p-datePicker>
        <label for="form-effective-end">Effective End</label>
      </p-iftaLabel>
    </div>
    <div class="field col-12 md:col-4">
      <p-iftaLabel>
        <p-select id="form-status" [options]="selectableStatusOptions" [(ngModel)]="costForm.status"
          optionLabel="label" optionValue="value" styleClass="w-full"></p-select>
        <label for="form-status">Status</label>
      </p-iftaLabel>
    </div>

    <div class="field col-12">
      <p-iftaLabel>
        <textarea id="form-notes" pInputTextarea [(ngModel)]="costForm.notes" rows="4"></textarea>
        <label for="form-notes">Notes</label>
      </p-iftaLabel>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button label="Cancel" severity="secondary" [text]="true" (onClick)="formVisible = false"></p-button>
    <p-button label="Save" icon="fa-solid fa-floppy-disk" [loading]="saving" (onClick)="saveCard()"></p-button>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="editRowDialogVisible" [modal]="true" [draggable]="false" [resizable]="false"
  [style]="{ width: 'min(900px, 96vw)' }" header="Edit Import Row">
  <div class="formgrid grid">
    <div class="field col-12 md:col-6" *ngFor="let column of importColumns">
      <p-iftaLabel>
        <input [id]="'row-' + column" pInputText [(ngModel)]="editingValues[column]" />
        <label [for]="'row-' + column">{{ column }}</label>
      </p-iftaLabel>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button label="Cancel" severity="secondary" [text]="true" (onClick)="editRowDialogVisible = false"></p-button>
    <p-button label="Save Row" icon="fa-solid fa-check" (onClick)="saveRow()"></p-button>
  </ng-template>
</p-dialog>
